<template>
  <ControlloDogane />
</template>

<script>
import ControlloDogane from '../components/pratiche/ControlloDogane.vue'

export default {
  components: {
    ControlloDogane,
  },
  mounted() {
    this.$eventBus.emit("page-change", {
      target: this,
      currentRoute: this.$router.currentRoute.value,
    });
  },
};
</script>

